import React from 'react';
import ProductsAndSystemsSection from './ProductsAndSystemsSection';

const ProductsAndSystemsSectionWithProps = (props: any) => {
  return (
    <ProductsAndSystemsSection
      sectionTitle={props.sectionTitle}
      sectionDescription={props.sectionDescription}
      systemEntries={props.systemEntry}
    />
  );
};

export default ProductsAndSystemsSectionWithProps;
